import {required} from "vuelidate/lib/validators";  
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric"; 
const StrOdenekTalep = {
  mixins: [Api, Sabit],
    data() {
      return { 
        StrOdenekTalepData:{
            Deleted: false,
            Birimid:null,
            Yil: 0,
            Ay: 0,
            Hesapkodid:null,
            Onay: false,
            Iptal: false,
            Revize: false,
            Serbestodenek: 0,
            Blokeodenek: 0,
            Harcananodenek: 0,
            Talepedilenodenek: 0,
            Karsilananodenek: 0, 
            Kalanodenek: 0,
            Aciklama: "",
            Onaypersonelid: null,
            Onayaciklama: "",
            Fileurl: "",
            Created : null,
            Gidertur: null,
            Program: null,
            Altprogram: null,
            Faaliyet: null,
            Altfaaliyet: null,
            Hesapkoduids: [],
            Grupguid: null,
            Iptalpersonelid: null,
            Iptalaciklama: "",
            

          },
        FormDataType:{ 

          Birimid:{FieldName:"Birimid",Field:"combobox",FieldTitle:this.$t('StrOdenekTalep.AddEdit.Birimid'),ComboDataArray:[]}, 
          Yil:{FieldName:"Yil",Field:"combobox",FieldTitle:this.$t('StrOdenekTalep.AddEdit.Yil'),ComboDataArray:[]},
          Ay:{FieldName:"Ay",Field:"input",FieldTitle: this.$t('StrOdenekTalep.AddEdit.Ay'),FieldType:"number"},
          Hesapkodid:{FieldName:"Hesapkodid",Field:"combobox",FieldTitle:this.$t('StrOdenekTalep.AddEdit.Hesapkodid'),ComboDataArray:[]}, 
          Hesapkoduids:{FieldName:"Hesapkoduids",Field:"combobox",FieldTitle:this.$t('StrOdenekTalep.AddEdit.Hesapkodid'),ComboDataArray:[]}, 
          Onay:{FieldName:"Onay",Field:"checkbox",FieldTitle: this.$t('StrOdenekTalep.AddEdit.Onay')},  
          Serbestodenek: {FieldName: "Serbestodenek",Field: "input",FieldTitle: this.$t("StrOdenekTalep.AddEdit.Serbestodenek"), FieldType: "number",},
          Blokeodenek: {FieldName: "Blokeodenek",Field: "input",FieldTitle: this.$t("StrOdenekTalep.AddEdit.Blokeodenek"), FieldType: "number",},
          Harcananodenek: {FieldName: "Serbestodenek",Field: "input",FieldTitle: this.$t("StrOdenekTalep.AddEdit.Harcananodenek"), FieldType: "number",},
          Kalanodenek: {FieldName: "Kalanodenek",Field: "input",FieldTitle: this.$t("StrOdenekTalep.AddEdit.Kalanodenek"), FieldType: "number",},
          Talepedilenodenek: {FieldName: "Talepedilenodenek",Field: "input",FieldTitle: this.$t("StrOdenekTalep.AddEdit.Talepedilenodenek"), FieldType: "number",},
          Karsilananodenek: {FieldName: "Karsilananodenek",Field: "input",FieldTitle: this.$t("StrOdenekTalep.AddEdit.Karsilananodenek"), FieldType: "number",},
          Aciklama:{FieldName:"Aciklama",Field:"input",FieldTitle: this.$t('StrOdenekTalep.AddEdit.Aciklama'),FieldType:"text"},
          Onayaciklama:{FieldName:"Onayaciklama",Field:"input",FieldTitle: this.$t('StrOdenekTalep.AddEdit.Onayaciklama'),FieldType:"text"},
          Onaypersonelid:{FieldName:"Onaypersonelid",Field:"input",FieldTitle:this.$t('StrOdenekTalep.AddEdit.Onaypersonelid')}, 
          Fileurl:{FieldName:"Fileurl",Field:"input",FieldTitle:"Dosya",FieldType:"text"},
          Gidertur:{FieldName:"Gidertur",Field:"combobox",FieldTitle:this.$t('StrOdenekTalep.AddEdit.Gidertur'),ComboDataArray:[]},
          Program:{FieldName:"Program",Field:"combobox",FieldTitle:this.$t('StrOdenekTalep.AddEdit.Program'),ComboDataArray:[]},
          Altprogram:{FieldName:"Altprogram",Field:"combobox",FieldTitle:this.$t('StrOdenekTalep.AddEdit.AltProgram'),ComboDataArray:[]},
          Faaliyet:{FieldName:"Faaliyet",Field:"combobox",FieldTitle:this.$t('StrOdenekTalep.AddEdit.Faaliyet'),ComboDataArray:[]},
          Altfaaliyet:{FieldName:"Altfaaliyet",Field:"combobox",FieldTitle:this.$t('StrOdenekTalep.AddEdit.AltFaaliyet'),ComboDataArray:[]},
          Iptalaciklama:{FieldName:"Iptalaciklama",Field:"input",FieldTitle: this.$t('StrOdenekTalep.AddEdit.Iptalaciklama'),FieldType:"text"},
          Iptalpersonelid:{FieldName:"Iptalpersonelid",Field:"input",FieldTitle:this.$t('StrOdenekTalep.AddEdit.Iptalpersonelid')}, 
          
        },

        Yillar:[
          {"id":"2023","value":"2023"},
          {"id":"2024","value":"2024"},
          {"id":"2025","value":"2025"},
          {"id":"2026","value":"2026"},
          {"id":"2027","value":"2027"},
          {"id":"2028","value":"2028"},
          {"id":"2029","value":"2029"},
          {"id":"2030","value":"2030"},

        ],
        Aylar:[
          {"id":"1","value":"Ocak"},
          {"id":"2","value":"Şubat"},
          {"id":"3","value":"Mart"},
          {"id":"4","value":"Nisan"},
          {"id":"5","value":"Mayıs"},
          {"id":"6","value":"Haziran"},
          {"id":"7","value":"Temmuz"},
          {"id":"8","value":"Ağustos"},
          {"id":"9","value":"Eylül"},
          {"id":"10","value":"Ekim"},
          {"id":"11","value":"Kasım"},
          {"id":"12","value":"Aralık"},

        ],
        Giderturs:[
          {"id":"1","value":"Personel Giderleri"},
          {"id":"2","value":"Diğer Giderler"}
        ],
 
      }
    },
    validations:{ 
        FormData: {
          Birimid:{required}, 
          Yil:{required},
          Ay:{required},
          Hesapkodid:{required}, 
          Onay:{},  
          Serbestodenek: {required},
          Blokeodenek: {required},
          Harcananodenek: {required},
          Talepedilenodenek: {required},
          Karsilananodenek: {},
          Kalanodenek: {},
          Aciklama:{},
          Onayaciklama: {},
          Onaypersonelid:{},
          Fileurl: {},
          Created: {},
          Gidertur: {required},
          Program: {},
          Altprogram: {},
          Faaliyet: {},
          Altfaaliyet: {},
          Hesapkoduids: {},
          Grupguid: {},
          Iptalpersonelid: {},
          Iptal : {},
          Iptalaciklama : {},
          Revize: {}
        } 
    },


    created(){ 
      let Page= {
        PageNumber: "1",
        PageSize: "9999"
      }


      let Filter2 = "&Tip=0";

      this.ActionsFilterGet({Service:"StrProgramFaaliyetKodlari",Page:Page, Filter:Filter2}).then(res => {  
        for(var c=0; c<res.Data.length; c++)
          {
            if(res.Data[c].Ustid == null){
            this.FormDataType.Program.ComboDataArray.push ({Id:res.Data[c].Id,Value:res.Data[c].Kod + "-" + res.Data[c].Aciklama})
              }
          }    
      }); 

      let Filter3 = "&Tip=1";

      this.ActionsFilterGet({Service:"StrProgramFaaliyetKodlari",Page:Page, Filter:Filter3}).then(res => {  
        for(var e=0; e<res.Data.length; e++)
          {
            if(res.Data[e].Ustid == null){
            this.FormDataType.Faaliyet.ComboDataArray.push ({Id:res.Data[e].Id,Value:res.Data[e].Kod + "-" + res.Data[e].Aciklama})
              }
          }    
      }); 
  
            var currentDate = new Date(); 
            this.FormDataType.Yil.ComboDataArray=[];
            for (var n=0 ; n<this.Yillar.length; n++){
      var Year =  currentDate.getFullYear()
              if(Year == this.Yillar[n].value){
                this.FormDataType.Yil.ComboDataArray.push ({Id:this.Yillar[n].id,Value:this.Yillar[n].value})
              }


            }

      this.FormDataType.Gidertur.ComboDataArray=[];
      for (var b=0 ; b<this.Giderturs.length; b++){
          this.FormDataType.Gidertur.ComboDataArray.push ({Id:this.Giderturs[b].id,Value:this.Giderturs[b].value})
      }


this.ActionsFilterGet({ Service: "StrParam", Page: Page, Filter: "&Tip=1" }).then(res => {

   let SonGun = parseInt(res.Data[0].Value);
  

  this.FormDataType.Ay.ComboDataArray = [];
  for (var i = 0; i < this.Aylar.length; i++) {
    var nextMonthNumber = currentDate.getMonth() + 2;
    if (nextMonthNumber > 12) {
      nextMonthNumber = 1;
    }

    if (currentDate.getDate() <= SonGun) {
      if (nextMonthNumber != 1) {
        if ((nextMonthNumber - 1) == this.Aylar[i].id) {
          this.FormDataType.Ay.ComboDataArray.push({ Id: this.Aylar[i].id, Value: this.Aylar[i].value });
        }
      } else {
        if ((12) == this.Aylar[i].id) {
          this.FormDataType.Ay.ComboDataArray.push({ Id: this.Aylar[i].id, Value: this.Aylar[i].value });
        }
      }
    }
    if (currentDate.getDay == 1) { 
      if (currentDate.getDate() == SonGun + 1 || currentDate.getDate() == SonGun + 2) { 
          if (nextMonthNumber != 1) {
            if ((nextMonthNumber - 1) == this.Aylar[i].id) {
              this.FormDataType.Ay.ComboDataArray.push({ Id: this.Aylar[i].id, Value: this.Aylar[i].value });
            }
          } else {
            if ((12) == this.Aylar[i].id) {
              this.FormDataType.Ay.ComboDataArray.push({ Id: this.Aylar[i].id, Value: this.Aylar[i].value });
            }
          }
      }
    }

    if (currentDate.getDate() > SonGun) {
      if (nextMonthNumber == this.Aylar[i].id) {
        this.FormDataType.Ay.ComboDataArray.push({ Id: this.Aylar[i].id, Value: this.Aylar[i].value });
      }
    }
  }
});


      
    }



}
export default StrOdenekTalep;